import { ReactNode } from "react"
import { css, cx } from "@emotion/css"
import { useI18n } from "providers/I18n"
import { ErrorBoundary } from "components/ErrorBoundary"
import FeedbackSnackbar from "components/FeedbackSnackbar"
import { Confirmation } from "components/Confirmation"

const styles = {
  root: css`
    padding: var(--spacing-xxl-2);
    padding-top: var(--spacing-m);
  `,
}

type PageContainerProps = {
  children: ReactNode
  className?: string
}

export function Container(props: PageContainerProps) {
  const { children, className } = props
  return (
    <div className={cx(styles.root, className)}>
      <ErrorBoundaryWrapped>
        {children}

        <Confirmation />
        <FeedbackSnackbar />
      </ErrorBoundaryWrapped>
    </div>
  )
}

export function ErrorBoundaryWrapped(props: { children: React.ReactNode }) {
  const { t } = useI18n()

  return <ErrorBoundary t={t}>{props.children}</ErrorBoundary>
}
